import { Box } from '@material-ui/core';
import { Currency } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import {
  EditAutoPaymentMethodLiveSummary,
  LiveSummaryCollapseIcon,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/components/EditAutoPaymentMethodLiveSummary';
import { FinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingLiveSummaryData';

const LIVE_SUMMARY_WIDTH = 436;
const LIVE_SUMMARY_COLLAPSED_PEEK = 40;

interface CollapsableLiveSummaryProps {
  showLiveSummary: boolean;
  setShowLiveSummary: Dispatch<SetStateAction<boolean>>;
  initialFormItem: AutomobileFormItem;
  initialFinancing: FinancingLiveSummaryData;
  currency: Currency;
  showVehicleSummary?: boolean;
  showFinancingSummary?: boolean;
  requiresFinancingReselection?: boolean;
}

export const CollapsableLiveSummary = ({
  showLiveSummary,
  setShowLiveSummary,
  initialFormItem,
  initialFinancing,
  currency,
  showVehicleSummary = true,
  showFinancingSummary = true,
  requiresFinancingReselection = false,
}: CollapsableLiveSummaryProps) => {
  return (
    <Box
      flexShrink={0}
      position="relative"
      width={showLiveSummary ? LIVE_SUMMARY_WIDTH : LIVE_SUMMARY_COLLAPSED_PEEK}
      style={{ transition: 'width 0.5s ease-in-out' }}
    >
      <Box position="absolute" top={-13} left={-14} zIndex={10}>
        <LiveSummaryCollapseIcon
          showLiveSummary={showLiveSummary}
          onToggle={() => setShowLiveSummary((prev) => !prev)}
        />
      </Box>
      <Box overflow="hidden" width="100%">
        <Box width={LIVE_SUMMARY_WIDTH}>
          <Box position="sticky" top={0} zIndex={1} overflow={'auto'}>
            <EditAutoPaymentMethodLiveSummary
              showVehicleSummary={showVehicleSummary}
              showFinancingSummary={showFinancingSummary}
              initialItem={initialFormItem}
              initialFinancing={initialFinancing}
              currency={currency}
              showLiveSummary={showLiveSummary}
              requiresFinancingReselection={requiresFinancingReselection}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
